// ── Service de Metas (núcleo/aplicação) ───────────────────────────
// Regras/validações do domínio. Recebe o repositório via porta (DI) — não
// conhece Supabase. Constantes de escopo (GOAL_SCOPES) são puras e ficam
// exportadas direto do módulo.

import type { GoalRow, GoalAchievementRow } from '@/types/goals';
import type {
  IGoalsRepository,
  ListGoalsParams,
  UpsertGoalParams,
  CopyFromPreviousMonthParams,
  GetGoalsAchievementParams,
} from '../ports/IGoalsRepository';

// ─── Constantes puras (sem Supabase) ────────────────────────────
export interface GoalScopeInfo {
  key: string;
  label: string;
  target: 'label' | 'user';
  unit: 'qtd' | 'brl';
}

export const GOAL_SCOPES: GoalScopeInfo[] = [
  { key: 'leads_origem',  label: 'Captação de Leads (por origem)', target: 'label', unit: 'qtd' },
  { key: 'leads_canal',   label: 'Captação de Leads (por canal)',  target: 'label', unit: 'qtd' },
  { key: 'receita_user',  label: 'Receita por usuário',            target: 'user',  unit: 'brl' },
  { key: 'receita_canal', label: 'Receita por canal',              target: 'label', unit: 'brl' },
];

// ─── Service com dependência do repositório ─────────────────────
export class GoalsService {
  constructor(private readonly repo: IGoalsRepository) {}

  listGoals = (params: ListGoalsParams): Promise<GoalRow[]> => {
    if (!params?.workspaceId) return Promise.resolve([]);
    return this.repo.listGoals(params);
  };

  upsertGoal = (params: UpsertGoalParams): Promise<GoalRow> => {
    if (!params?.workspaceId) throw new Error('workspaceId é obrigatório.');
    if (!params?.scope)       throw new Error('scope é obrigatório.');
    if (!params?.periodKey)   throw new Error('periodKey é obrigatório.');
    if (params?.valor === undefined || params?.valor === null || Number.isNaN(Number(params.valor))) {
      throw new Error('valor é obrigatório.');
    }
    return this.repo.upsertGoal(params);
  };

  deleteGoal = (id: string): Promise<void> => {
    if (!id) throw new Error('id é obrigatório.');
    return this.repo.deleteGoal(id);
  };

  copyFromPreviousMonth = (params: CopyFromPreviousMonthParams): Promise<{ copied: number; skipped: number }> => {
    if (!params?.workspaceId || !params?.scope || !params?.periodKey) {
      throw new Error('Parâmetros obrigatórios ausentes.');
    }
    return this.repo.copyFromPreviousMonth(params);
  };

  getGoalsAchievement = (params: GetGoalsAchievementParams): Promise<GoalAchievementRow[]> => {
    if (!params?.workspaceId || !params?.period || !params?.scope) return Promise.resolve([]);
    return this.repo.getGoalsAchievement(params);
  };
}
